<!-- START: Section 1 -->
<section class="quotation-video-wrapper color-gray-light">
  <div class="box-container">
    <div class="box">
      <div class="box__left">
        <!-- desktop heading -->
        <div class="box__heading color-gray box__heading--desktop" [innerHtml]="'QUOTATION.VIDEO.HEADING' | translate">
        </div>

        <!-- tablet heading -->
        <div
          class="box__heading color-gray box__heading--tablet"
          [innerHtml]="'QUOTATION.VIDEO.HEADING_TABLET' | translate"
        >
        </div>

        <!-- mobile heading -->
        <div
          class="box__heading color-gray box__heading--mobile"
          [innerHtml]="'QUOTATION.VIDEO.HEADING_MOBILE' | translate"
        >
        </div>

        <!-- ยังไม่มี Eng กำลังทำอยู่ เลยขอซ่อนการแสดงผลส่วนนี้ในหน้า en ออกไปก่อน -->
        <ng-container *ngIf="translate.currentLang === 'th'">
          <div class="box__heading-detail box__heading--mw">
            {{ 'QUOTATION.VIDEO.DETAIL' | translate }}
          </div>
        </ng-container>

        <div class="box__link">
          <a
            href="{{ sharedService.getTutorialsPath(translate.currentLang) }}"
            class="link-app-line read-more"
            aria-label="read-more"
          >
            <span> {{ 'QUOTATION.VIDEO.LINK' | translate }}</span
            ><i class="fas fa-angle-right right"></i>
          </a>
        </div>
      </div>
      <div class="box__right">
        <div class="box__item" (click)="linkVideo('RWcDBZozpMY')" data-toggle="modal" data-target="#functionVideo">
          <div class="box__item-cover">
            <div class="box__item-cover--bg"></div>
            <picture>
              <source
                srcset="https://flowaccountcdn.com/new_landing/image/functions/quotation/quotation-section-4-v4.webp"
                type="image/webp"
              />
              <img
                src="https://flowaccountcdn.com/new_landing/image/functions/quotation/quotation-section-4-v4.png"
                class="box__image"
                alt="สอนทำใบเสนอราคา"
                title="สอนทำใบเสนอราคา"
                loading="lazy"
              />
            </picture>

            <div class="box__item-cover--icon">
              <picture>
                <source
                  srcset="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.webp"
                  type="image/webp"
                />
                <img
                  src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                  class="icon-play"
                  alt="FlowAccount Testimonials"
                  loading="lazy"
                />
              </picture>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- END: Section 1 -->
